import BasePropertyView from 'BasePropertyView.js';
import _template from 'properties/table/column-mandatory.ejs';
import StageAndRoleSettingsModal from 'common-views/StageAndRoleSettingsModal.js';
import settingsService from 'MandatoryAndStateSettingsService.js';
import constants from 'Constants.js';
import listService from 'ListService.js';
import util from "util/Util";

// PF-5745
import undoService from 'UndoService';
import textConstants from 'TextConstants';

class ColumnMandatoryView extends BasePropertyView {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'change input[type=text]'  : 'updateAttributes',
            'blur input[type=text]'    : 'lostFocus',
            'focus input[type=text]'   : 'getFocus',
            'change input[type=checkbox]' : 'updateCheckAttributes',
            'click #mandatoryState'    : 'displayStagesRolesModal'
        };

        if(this.colId){
            let factorykey=this.model.get('gridData')[this.colId].get('factoryKey');
            util.updateHelpDocumentationLink(factorykey);
        }
        // Add needed property
        if (!this.model.get('gridData')[this.colId].attributes['mandatories']) {
            this.model.get('gridData')[this.colId].attributes['mandatories'] = new Map();
        }

        //this.listenTo(this.model, 'change', this.render);
        this.listenTo(this.model, constants.EV_ISMANDATORY_ROLE_OR_STAGE_UPDATED, this.render);
        return this;
    }

    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = util.sanitizeHTML(ev.currentTarget.value, true, this.model.get(propName));
        const oldVal = this.model.get('gridData')[this.colId].attributes[propName];
        const colId = this.colId;

        this.model.get('gridData')[this.colId].attributes[propName] = propVal;

        // PF-5745
        undoService.add({
            undo: () =>{
                this.model.get('gridData')[colId].attributes[propName] = oldVal;
                this.render();
            },
            redo:() => {
                this.model.get('gridData')[colId].attributes[propName] = propVal;
                this.render();
            }
        },textConstants.UNDO_MOVE);
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.checked;
        const oldSetting = this.model.get('gridData')[this.colId].attributes['mandatories'];
        const colId = this.colId;
        const currentKey = this.getCurrentKey();
        
        this.model.get('gridData')[this.colId].attributes['mandatories'].clear();

        let newValue = "no";
        if (propVal) {
            newValue = "yes";
        }

        this.model.get('gridData')[this.colId].attributes[propName] = propVal;
        
        const newSetting = settingsService.createSetting(listService.getCurrentStage(), listService.getCurrentRole(), 'required', newValue);
        this.model.get('gridData')[this.colId].attributes['mandatories'].set(this.getCurrentKey(), newSetting);

        // PF-5745
        undoService.add({
            undo: () =>{
                console.log('undo column mandatory');
                this.model.get('gridData')[colId].attributes['mandatories'].set(currentKey, oldSetting);
                
                this.render();
            },
            redo:() => {
                console.log('redo column mandatory');
                this.model.get('gridData')[colId].attributes['mandatories'].set(currentKey, newSetting);

                this.render();
            }
        },textConstants.UNDO_MANDATORY_CHECK);

    }

    getCurrentKey(){
        return settingsService.getSettingKey(listService.getCurrentStage(), listService.getCurrentRole());
    }

    displayStagesRolesModal(ev){
        ev.preventDefault();
        const alertVIew = new StageAndRoleSettingsModal({settings: this.model.get('gridData')[this.colId].attributes['mandatories'], model: this.model});
        alertVIew.render();
    }

    mandatorySelected() {
        return settingsService.getSetting({
            stageId: listService.getCurrentStage(),
            roleId: listService.getCurrentRole(),
            settings: this.model.get('gridData')[this.colId].attributes['mandatories'],
            defaultValue: false,
            settingsField: "required"
        });
    }

    getViewValues() {
        let isMandatory = util.isTrue(this.mandatorySelected());
        _.merge(this.model.get('gridData')[this.colId].attributes, { isMandatory: isMandatory });
        return this.model.toJSON();
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.getViewValues()));
        }

        this.addMultilanguageIcon();

        this.delegateEvents();
        return this;
    }

}

export default ColumnMandatoryView;
